// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    InvoiceItem,
    InvoiceItemFromJSON,
    InvoiceItemToJSON,
    InvoiceStatusType,
    InvoiceStatusTypeFromJSON,
    InvoiceStatusTypeToJSON,
    InvoiceType,
    InvoiceTypeFromJSON,
    InvoiceTypeToJSON,
    Revision,
    RevisionFromJSON,
    RevisionToJSON,
} from './';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * CustomerInvoiceId
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    id?: string;
    /**
     * Description of invoice
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    description?: string;
    /**
     * Internal memo field
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    memo?: string;
    /**
     * Note for the recipient
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    note?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof Invoice
     */
    amount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof Invoice
     */
    paidAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof Invoice
     */
    remainingAmountDue?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof Invoice
     */
    stripeAmount?: Amount;
    /**
     * Invoice status of the underlying stripe invoice
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    stripeStatus?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof Invoice
     */
    created?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof Invoice
     */
    invoiceDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof Invoice
     */
    dueDate?: string;
    /**
     * The customer invoice group id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    groupId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof Invoice
     */
    groupCreateDate?: string;
    /**
     * The customer invoice is the latest in the group
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof Invoice
     */
    latestResourceInGroup?: boolean;
    /**
     * 
     * OpenAPI data type: {InvoiceType}
     * @type {InvoiceType}
     * @memberof Invoice
     */
    invoiceType?: InvoiceType;
    /**
     * 
     * OpenAPI data type: {InvoiceStatusType}
     * @type {InvoiceStatusType}
     * @memberof Invoice
     */
    invoiceStatus?: InvoiceStatusType;
    /**
     * If a checkout url is linked
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    collectionUrl?: string;
    /**
     * Line items for invoice
     * OpenAPI data type: {array}
     * @type {Array<InvoiceItem>}
     * @memberof Invoice
     */
    items?: Array<InvoiceItem>;
    /**
     * Other customer invoices in customer invoice group
     * OpenAPI data type: {array}
     * @type {Array<Revision>}
     * @memberof Invoice
     */
    revisions?: Array<Revision>;
    /**
     * Deprecated (Url for making a payment)
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Invoice
     */
    checkoutUrl?: string;
}

export function InvoiceFromJSON(json: any): Invoice {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'description': !exists(json, 'description') ? undefined : json['description'],
            'memo': !exists(json, 'memo') ? undefined : json['memo'],
            'note': !exists(json, 'note') ? undefined : json['note'],
            'amount': !exists(json, 'amount') ? undefined : AmountFromJSON(json['amount']),
            'paidAmount': !exists(json, 'paidAmount') ? undefined : AmountFromJSON(json['paidAmount']),
            'remainingAmountDue': !exists(json, 'remainingAmountDue') ? undefined : AmountFromJSON(json['remainingAmountDue']),
            'stripeAmount': !exists(json, 'stripeAmount') ? undefined : AmountFromJSON(json['stripeAmount']),
            'stripeStatus': !exists(json, 'stripeStatus') ? undefined : json['stripeStatus'],
            'created': !exists(json, 'created') ? undefined : json['created'],
            'invoiceDate': !exists(json, 'invoiceDate') ? undefined : json['invoiceDate'],
            'dueDate': !exists(json, 'dueDate') ? undefined : json['dueDate'],
            'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
            'groupCreateDate': !exists(json, 'groupCreateDate') ? undefined : json['groupCreateDate'],
            'latestResourceInGroup': !exists(json, 'latestResourceInGroup') ? undefined : json['latestResourceInGroup'],
            'invoiceType': !exists(json, 'invoiceType') ? undefined : InvoiceTypeFromJSON(json['invoiceType']),
            'invoiceStatus': !exists(json, 'invoiceStatus') ? undefined : InvoiceStatusTypeFromJSON(json['invoiceStatus']),
            'collectionUrl': !exists(json, 'collectionUrl') ? undefined : json['collectionUrl'],
            'items': !exists(json, 'items') ? undefined : (json['items'] as Array<any>).map(InvoiceItemFromJSON),
            'revisions': !exists(json, 'revisions') ? undefined : (json['revisions'] as Array<any>).map(RevisionFromJSON),
            'checkoutUrl': !exists(json, 'checkoutUrl') ? undefined : json['checkoutUrl'],
    };

}

export function InvoiceToForm(value?: Invoice): any {
    let jsonVal = InvoiceToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function InvoiceToJSON(value?: Invoice): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'description': cleanupBlankValuesForBackend(value.description),
            'memo': cleanupBlankValuesForBackend(value.memo),
            'note': cleanupBlankValuesForBackend(value.note),
            'amount': AmountToJSON(value.amount),
            'paidAmount': AmountToJSON(value.paidAmount),
            'remainingAmountDue': AmountToJSON(value.remainingAmountDue),
            'stripeAmount': AmountToJSON(value.stripeAmount),
            'stripeStatus': cleanupBlankValuesForBackend(value.stripeStatus),
            'created': cleanupBlankValuesForBackend(value.created),
            'invoiceDate': cleanupBlankValuesForBackend(value.invoiceDate),
            'dueDate': cleanupBlankValuesForBackend(value.dueDate),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'groupCreateDate': cleanupBlankValuesForBackend(value.groupCreateDate),
            'latestResourceInGroup': cleanupBlankValuesForBackend(value.latestResourceInGroup),
            'invoiceType': InvoiceTypeToJSON(value.invoiceType),
            'invoiceStatus': InvoiceStatusTypeToJSON(value.invoiceStatus),
            'collectionUrl': cleanupBlankValuesForBackend(value.collectionUrl),
            'items': (value.items === undefined || value.items === null) ? undefined : (value.items as Array<any>).map(InvoiceItemToJSON),
            'revisions': (value.revisions === undefined || value.revisions === null) ? undefined : (value.revisions as Array<any>).map(RevisionToJSON),
            'checkoutUrl': cleanupBlankValuesForBackend(value.checkoutUrl),
    };
}


